var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQueryBuilder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 8C17.11 8 16 6.88 16 5.5C16 4.11 17.11 3 18.5 3C19.88 3 21 4.11 21 5.5C21 6.88 19.88 8 18.5 8ZM18.5 21C17.11 21 16 19.88 16 18.5C16 17.11 17.11 16 18.5 16C19.88 16 21 17.11 21 18.5C21 19.88 19.88 21 18.5 21ZM5.5 21C4.11 21 3 19.88 3 18.5C3 17.11 4.11 16 5.5 16C6.88 16 8 17.11 8 18.5C8 19.88 6.88 21 5.5 21Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 8C4.11 8 3 6.88 3 5.5C3 4.11 4.11 3 5.5 3C6.88 3 8 4.11 8 5.5C8 6.88 6.88 8 5.5 8ZM11 4H13C13.55 4 14 4.44 14 5C14 5.55 13.55 6 13 6H11C10.44 6 10 5.55 10 5C10 4.44 10.44 4 11 4ZM11 18H13C13.55 18 14 18.44 14 19C14 19.55 13.55 20 13 20H11C10.44 20 10 19.55 10 19C10 18.44 10.44 18 11 18ZM5 10C5.55 10 6 10.44 6 11V13C6 13.55 5.55 14 5 14C4.44 14 4 13.55 4 13V11C4 10.44 4.44 10 5 10ZM19 10C19.55 10 20 10.44 20 11V13C20 13.55 19.55 14 19 14C18.44 14 18 13.55 18 13V11C18 10.44 18.44 10 19 10Z",
    fill: "#8F8F8F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryBuilder);
export default __webpack_public_path__ + "static/media/query-builder.3709deec.svg";
export { ForwardRef as ReactComponent };